export const CUSTOM_FIELD_VALUES = {
  'customfield_10140':   '10291',
  'customfield_10140:1': '11222',
  'recordWebInfo': '1',
  'recordWebInfoConsent': ['1'],
};
